export const GET_ALL_REVIEW_BY_PRODUCT_REQUEST = "GET_ALL_REVIEW_BY_PRODUCT_REQUEST";
export const GET_ALL_REVIEW_BY_PRODUCT_FAILURE = "GET_ALL_REVIEW_BY_PRODUCT_FAILURE";
export const GET_ALL_REVIEW_BY_PRODUCT_SUCCESS = "GET_ALL_REVIEW_BY_PRODUCT_SUCCESS";

export const CREATE_REVIEW_REQUEST = "CREATE_REVIEW_REQUEST";
export const CREATE_REVIEW_FAILURE = "CREATE_REVIEW_FAILURE";
export const CREATE_REVIEW_SUCCESS = "CREATE_REVIEW_SUCCESS";

export const DELETE_REVIEW_FAILURE = "DELETE_REVIEW_FAILURE";
export const DELETE_REVIEW_SUCCESS = "DELETE_REVIEW_SUCCESS";
export const DELETE_REVIEW_REQUEST = "DELETE_REVIEW_REQUEST";